export default {
    methods: {
        uppercase(value, event) {
        // vue needs this setTimeout to avoid moving cursor to the end of the string
            const {
                target: {
                  selectionEnd,
                  selectionStart
                }
              } = event
        
              setTimeout(() => {
                event.target.selectionStart = selectionStart;
                event.target.selectionEnd = selectionEnd;
              })
            return value.toUpperCase();
        },
        lowercase(value, event) {
        // vue needs this setTimeout to avoid moving cursor to the end of the string
            const {
                target: {
                  selectionEnd,
                  selectionStart
                }
              } = event
        
              setTimeout(() => {
                event.target.selectionStart = selectionStart;
                event.target.selectionEnd = selectionEnd;
              })
            return value.toLowerCase();
        }
    },
}